import moment from "moment";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";

import MUIAddIcon from "@mui/icons-material/Add";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";
import MUICheckIcon from "@mui/icons-material/Check";
import MUICloseIcon from "@mui/icons-material/Close";
import MUITypography from "@mui/material/Typography";
import MUIIconButton from "@mui/material/IconButton";
import MUIButton from "@mui/material/Button";
import MUIStack from "@mui/material/Stack";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUITableContainer from "@mui/material/TableContainer";
import MUITable from "@mui/material/Table";
import MUITableHead from "@mui/material/TableHead";
import MUITableRow from "@mui/material/TableRow";
import MUITableCell from "@mui/material/TableCell";
import MUITableBody from "@mui/material/TableBody";

import CardClass from "../../../CardClass";
import TileUser from "../../../Tile/TileUser";
import MainContext from "../../../../Context/MainContext/MainContext";
import DialogSearchUser from "../../../Dialog/Search/DialogSearchUser";
export default class CardAdminLocationSales extends CardClass {
  componentDidMount() {
    let tierPoints =
      this.props.location && this.props.location.jsonTierPoints
        ? JSON.parse(this.props.location.jsonTierPoints)
        : [];
    if (tierPoints.length === 0) {
      const blankTier = {
        begin: null,
        end: null,
        tier1Points: 0,
        tier2Points: 0,
        tier3Points: 0,
      };
      if (this.state.editingTierIdx !== 0 || !this.state.editingTier) {
        this.setState({ editingTierIdx: 0, editingTier: { ...blankTier } });
      }
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      billingLocationDialogOpen: false,
      editingTierIdx: null,
      editingTier: null,
    };
  }

  static contextType = MainContext; // For legacy class components

  /**
   * Change handler that sets int values or null when cleared
   */
  handleIntChange = (key) => (e) => {
    const raw = e.target.value;

    if (raw === "" || raw === null) {
      this.props.onChange({ [key]: null });
      return;
    }

    let num = parseInt(raw, 10);

    if (Number.isNaN(num)) {
      this.props.onChange({ [key]: null });
      return;
    }
    if (num < 1) {
      num = 1;
    }

    this.props.onChange({ [key]: num });
  };

  /**
   * Render the content of the card.
   */
  renderContent() {
    let salesManager = null;

    if (
      this.props.location &&
      this.props.location.salesManagerUserprofileId !== null
    ) {
      salesManager =
        this.context.usersIndexed[
          this.props.location.salesManagerUserprofileId
        ];
    }

    // Sales Manager
    const handleEditSalesManager = () => {
      this.setState({ salesManagerDialogOpen: true });
    };
    const handleClearSalesManager = () => {
      this.props.onChange({ salesManagerUserprofileId: null });
    };
    const salesManagerIconButtons = [
      <MUIIconButton onClick={handleEditSalesManager}>
        <MUIEditIcon />
      </MUIIconButton>,
    ];

    if (salesManager) {
      salesManagerIconButtons.push(
        <MUIIconButton onClick={handleClearSalesManager}>
          <MUIDeleteIcon />
        </MUIIconButton>,
      );
    }

    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={4}>
          <TileUser
            user={salesManager}
            iconButtons={salesManagerIconButtons}
            label="Sales Manager"
          />
        </MUIGrid>
        <MUIGrid item xs={12}>
          {this.renderTiersTable()}
        </MUIGrid>
        <DialogSearchUser
          open={this.state.salesManagerDialogOpen}
          onClose={() => this.setState({ salesManagerDialogOpen: false })}
          onSelect={(user) => {
            console.log(user);
            this.props.onChange({ salesManagerUserprofileId: user.id });
          }}
        />
      </MUIGrid>
    );
  }
  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Sales";
  }

  /**
   * Render the Tiers table using mocked jsonTierPoints data
   */
  renderTiersTable() {
    // Helper to format date for view mode (full date) or edit mode (month/year)
    function formatDate(dateString) {
      if (!dateString) {
        return "Current";
      } else {
        return moment(dateString, "YYYY-MM-DD", true).format("MMMM D, YYYY");
      }
    }

    // Parse and handle empty/null tier data
    let tierPoints =
      this.props.location && this.props.location.jsonTierPoints
        ? JSON.parse(this.props.location.jsonTierPoints)
        : [];

    // If no data, create a dummy (but do NOT setState here)
    if (tierPoints.length === 0) {
      tierPoints = [
        {
          begin: null,
          end: null,
          tier1Points: 0,
          tier2Points: 0,
          tier3Points: 0,
        },
      ];
    }

    // Sort by most recent begin date (descending)
    const sorted = [...tierPoints].sort((a, b) => {
      if (!a.begin && !b.begin) {
        return 0;
      }
      if (!a.begin) {
        return -1;
      }
      if (!b.begin) {
        return 1;
      }
      const ma = moment(a.begin, ["YYYY-MM-DD", "YYYY-MM"]);
      const mb = moment(b.begin, ["YYYY-MM-DD", "YYYY-MM"]);
      if (mb.isAfter(ma)) {
        return 1;
      } else if (mb.isBefore(ma)) {
        return -1;
      } else {
        return 0;
      }
    });

    // Handler to delete a row and update the JSON string
    const handleDeleteRow = (deleteIdx) => {
      const updated = sorted.filter((_, idx) => idx !== deleteIdx);
      if (this.props.onChange) {
        this.props.onChange({ jsonTierPoints: JSON.stringify(updated) });
      }
      if (this.state.editingTierIdx === deleteIdx) {
        this.setState({ editingTierIdx: null, editingTier: null });
      }
    };

    // Handler to start editing a row
    const handleEditRow = (editIdx) => {
      this.setState({
        editingTierIdx: editIdx,
        editingTier: { ...sorted[editIdx] },
      });
    };

    // Handler to change a field in the editing row
    const handleEditField = (field, value) => {
      let newValue = value;
      if (field === "begin" && value) {
        newValue = moment(value, "YYYY-MM-DD")
          .startOf("month")
          .format("YYYY-MM-DD");
      }
      if (field === "end" && value) {
        newValue = moment(value, "YYYY-MM-DD")
          .endOf("month")
          .format("YYYY-MM-DD");
      }
      this.setState({
        editingTier: { ...this.state.editingTier, [field]: newValue },
      });
    };

    // Handler to save the edited row
    const handleSaveEdit = (editIdx) => {
      const updated = sorted.map((row, idx) =>
        idx === editIdx ? this.state.editingTier : row,
      );
      if (this.props.onChange) {
        this.props.onChange({ jsonTierPoints: JSON.stringify(updated) });
      }
      this.setState({ editingTierIdx: null, editingTier: null });
    };

    // Handler to cancel editing
    const handleCancelEdit = () => {
      this.setState({ editingTierIdx: null, editingTier: null });
    };

    return (
      <>
        <MUIStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 1 }}
        >
          <MUITypography variant="body2" color="text.secondary">
            Tiers
          </MUITypography>
          <MUIButton
            variant="outlined"
            size="small"
            startIcon={<MUIAddIcon />}
            onClick={() => {
              const blankTier = {
                begin: null,
                end: null,
                tier1Points: 0,
                tier2Points: 0,
                tier3Points: 0,
              };
              let tierPoints =
                this.props.location && this.props.location.jsonTierPoints
                  ? JSON.parse(this.props.location.jsonTierPoints)
                  : [];
              const newTiers = [blankTier, ...tierPoints];
              if (this.props.onChange) {
                this.props.onChange({
                  jsonTierPoints: JSON.stringify(newTiers),
                });
              }
              this.setState({
                editingTierIdx: 0,
                editingTier: { ...blankTier },
              });
            }}
          >
            Add
          </MUIButton>
        </MUIStack>
        <MUITableContainer>
          <MUITable size="small">
            <MUITableHead
              sx={{
                backgroundColor: (theme) => theme.palette.background.default,
              }}
            >
              <MUITableRow>
                <MUITableCell sx={{ width: "20%" }}>Begin</MUITableCell>
                <MUITableCell sx={{ width: "20%" }}>End</MUITableCell>
                <MUITableCell sx={{ width: "15%" }}>Tier 1 Points</MUITableCell>
                <MUITableCell sx={{ width: "15%" }}>Tier 2 Points</MUITableCell>
                <MUITableCell sx={{ width: "15%" }}>Tier 3 Points</MUITableCell>
                <MUITableCell align="right" sx={{ width: "15%" }} />
              </MUITableRow>
            </MUITableHead>
            <MUITableBody>
              {sorted.map((row, idx) => {
                const isEditing = this.state.editingTierIdx === idx;
                return (
                  <MUITableRow key={idx}>
                    <MUITableCell>
                      {isEditing ? (
                        <MUIDatePicker
                          views={["year", "month"]}
                          openTo="month"
                          inputFormat="MMM YYYY"
                          value={
                            this.state.editingTier.begin
                              ? moment(this.state.editingTier.begin, [
                                  "YYYY-MM-DD",
                                  "YYYY-MM",
                                ])
                              : null
                          }
                          onChange={(val) =>
                            handleEditField(
                              "begin",
                              val ? val.format("YYYY-MM") : "",
                            )
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              variant: "standard",
                              InputLabelProps: { shrink: true },
                              sx: { minWidth: 100, mb: 0 },
                            },
                          }}
                        />
                      ) : (
                        formatDate(row.begin)
                      )}
                    </MUITableCell>
                    <MUITableCell>
                      {isEditing ? (
                        <MUIDatePicker
                          views={["year", "month"]}
                          openTo="month"
                          inputFormat="MMM YYYY"
                          value={
                            this.state.editingTier.end
                              ? moment(this.state.editingTier.end, [
                                  "YYYY-MM-DD",
                                  "YYYY-MM",
                                ])
                              : null
                          }
                          onChange={(val) =>
                            handleEditField(
                              "end",
                              val ? val.format("YYYY-MM") : "",
                            )
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              variant: "standard",
                              InputLabelProps: { shrink: true },
                              sx: { minWidth: 100, mb: 0 },
                            },
                          }}
                        />
                      ) : (
                        formatDate(row.end)
                      )}
                    </MUITableCell>
                    <MUITableCell>
                      {isEditing ? (
                        <MUITextField
                          value={this.state.editingTier.tier1Points}
                          type="number"
                          size="small"
                          variant="standard"
                          inputProps={{ min: 1, step: 1, inputMode: "numeric" }}
                          onChange={(e) =>
                            handleEditField(
                              "tier1Points",
                              parseInt(e.target.value, 10) || 0,
                            )
                          }
                          style={{ minWidth: 60 }}
                        />
                      ) : (
                        row.tier1Points
                      )}
                    </MUITableCell>
                    <MUITableCell>
                      {isEditing ? (
                        <MUITextField
                          value={this.state.editingTier.tier2Points}
                          type="number"
                          size="small"
                          variant="standard"
                          inputProps={{ min: 1, step: 1, inputMode: "numeric" }}
                          onChange={(e) =>
                            handleEditField(
                              "tier2Points",
                              parseInt(e.target.value, 10) || 0,
                            )
                          }
                          style={{ minWidth: 60 }}
                        />
                      ) : (
                        row.tier2Points
                      )}
                    </MUITableCell>
                    <MUITableCell>
                      {isEditing ? (
                        <MUITextField
                          value={this.state.editingTier.tier3Points}
                          type="number"
                          size="small"
                          variant="standard"
                          inputProps={{ min: 1, step: 1, inputMode: "numeric" }}
                          onChange={(e) =>
                            handleEditField(
                              "tier3Points",
                              parseInt(e.target.value, 10) || 0,
                            )
                          }
                          style={{ minWidth: 60 }}
                        />
                      ) : (
                        row.tier3Points
                      )}
                    </MUITableCell>
                    <MUITableCell
                      align="right"
                      sx={{ width: 110, minWidth: 110, maxWidth: 110 }}
                    >
                      {isEditing ? (
                        <>
                          <MUIIconButton
                            onClick={() => handleSaveEdit(idx)}
                            size="small"
                          >
                            <MUICheckIcon
                              fontSize="small"
                              style={{ color: "green" }}
                            />
                          </MUIIconButton>
                          <MUIIconButton
                            onClick={handleCancelEdit}
                            size="small"
                          >
                            <MUICloseIcon
                              fontSize="small"
                              style={{ color: "gray" }}
                            />
                          </MUIIconButton>
                        </>
                      ) : (
                        <>
                          <MUIIconButton
                            onClick={() => handleEditRow(idx)}
                            size="small"
                          >
                            <MUIEditIcon fontSize="small" />
                          </MUIIconButton>
                          <MUIIconButton
                            onClick={() => handleDeleteRow(idx)}
                            size="small"
                          >
                            <MUIDeleteIcon fontSize="small" />
                          </MUIIconButton>
                        </>
                      )}
                    </MUITableCell>
                  </MUITableRow>
                );
              })}
            </MUITableBody>
          </MUITable>
        </MUITableContainer>
        {this.props.validationIssues &&
          this.props.validationIssues.jsonTierPoints && (
            <MUITypography
              color="error"
              variant="caption"
              sx={{ mt: 1, display: "block" }}
            >
              {this.props.validationIssues.jsonTierPoints}
            </MUITypography>
          )}
      </>
    );
  }
}
